import React from 'react';
import { Box, Chip, Typography, Skeleton } from '@mui/material';

const EstimateFilter = ({
  summary = [],
  selectedEstimate,
  onSelectEstimate,
  loading = false
}) => {
  if (loading) {
    return (
      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 2 }}>
        {[1, 2, 3, 4, 5, 6].map((i) => (
          <Skeleton key={i} variant="rounded" width={60} height={32} />
        ))}
      </Box>
    );
  }

  if (!summary || summary.length === 0) {
    return (
      <Box sx={{ mb: 2 }}>
        <Typography variant="body2" color="text.secondary">
          No estimated items found
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>
        Filter by Estimate
      </Typography>
      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
        <Chip
          label="All"
          onClick={() => onSelectEstimate(null)}
          color={selectedEstimate === null ? 'primary' : 'default'}
          variant={selectedEstimate === null ? 'filled' : 'outlined'}
          sx={{ fontWeight: selectedEstimate === null ? 600 : 400 }}
        />
        {summary.map((item) => (
          <Chip
            key={item.estimate}
            label={
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <span>{item.estimate}</span>
                <Typography
                  component="span"
                  variant="caption"
                  sx={{
                    color: selectedEstimate === item.estimate
                      ? 'inherit'
                      : 'text.secondary',
                    fontSize: '0.7rem'
                  }}
                >
                  ({item.count})
                </Typography>
              </Box>
            }
            onClick={() => onSelectEstimate(item.estimate)}
            color={selectedEstimate === item.estimate ? 'primary' : 'default'}
            variant={selectedEstimate === item.estimate ? 'filled' : 'outlined'}
            sx={{ fontWeight: selectedEstimate === item.estimate ? 600 : 400 }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default EstimateFilter;
